import { Guide, HelpGuideCardProps } from 'appJS/components/HelpGuideCard';
import * as translations from './strings';
import { getLangKey } from '../../../../javascript/models/Language';
import { getGuideLink } from 'appJS/utils/HelpArticleButton';
const strings = translations[getLangKey()];

export const helpGuides = (): { [key: string]: HelpGuideCardProps } => {
  const workflowLink = getGuideLink({
    articleKey: 'defineYourWorkflow',
    text: strings.bestWorkflow
  });
  const installLink = getGuideLink({ articleKey: 'installingBugherd' });
  const clientFeedbackLink = getGuideLink({
    articleKey: 'clientFeedbackTips'
  });

  return {
    integrations: {
      guide: Guide.IntegrationSettings,
      header: strings.integrationsGuideHeader,
      message: strings.integrationsGuideDescription,
      links: [
        workflowLink,
        {
          text: strings.setItUp,
          link: '/collections/12945768-integrations',
          articleId: 12945768
        }
      ],
      divider: true,
      isAdminView: true
    },
    install: {
      guide: Guide.InstallSettings,
      header: strings.installingBugherd,
      message: strings.installMethod,
      guideButton: installLink,
      isAdminView: true
    },
    clientPermissions: {
      guide: Guide.ClientPermissionSettings,
      header: strings.clientFeedbackTipsHeader,
      message: strings.clientFeedbackTipsDescription,
      guideButton: clientFeedbackLink,
      isAdminView: true
    }
  };
};
